
import { compose } from 'recompose';
import ArchivedEmail from './ArchivedEmail';
import apiInterceptor from '../../api/interceptor';
import { archivedEmailApi } from '../common/base.api';

const composedArchivedEmail = compose(apiInterceptor({ ...archivedEmailApi }))(ArchivedEmail);

export default composedArchivedEmail;
